<template>
    <div class="table-user">
        <div class="table-user-header">
            <b-row class="pb-3">
                <b-col>
                    Filters for Inventory Excess
                </b-col>
            </b-row>
        </div>
        <div class="scroll-x">
        </div>
        <div class="table-user-footer">
        </div>
    </div>
</template>

<script>
    import TableElement from '~cp/UserPanel/Elements/TableElement'

    export default {
        name: 'InventoryExcess',
        components: {
            TableElement
        },
        data() {
            return {
                endpoint: '',
                fields: []
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Reports/InventoryRreport/InventoryExcess.vue